/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_What_P2Inputs */

const en_wc_what_p2 = /** @type {(inputs: Wc_What_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose WordCraft for desktop if you want to write offline using native file dialogs. Our download guide lists Windows, macOS and Linux builds, installation steps, release notes and checksums. Desktop links go to the developers' GitHub releases.`)
};

/**
* | output |
* | --- |
* | "Choose WordCraft for desktop if you want to write offline using native file dialogs. Our download guide lists Windows, macOS and Linux builds, installation s..." |
*
* @param {Wc_What_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_what_p2 = /** @type {((inputs?: Wc_What_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_What_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_what_p2(inputs)
});
export { wc_what_p2 as "wc.what.p2" }